// Kannada translations for articles, gallery captions, and quiz Q&A.

export const articleTranslationsKN = {
    "choosing-your-first-dairy-cow": {
        title: "ನಿಮ್ಮ ಮೊದಲ ಹಾಲಿನ ಹಸು ಆಯ್ಕೆ",
        excerpt: "ಹೊಸ ಹೈನುಗಾರ ತೆಗೆದುಕೊಳ್ಳುವ ಅತ್ಯಂತ ಮುಖ್ಯ ನಿರ್ಧಾರ. ಹವಾಮಾನ, ಮಾರುಕಟ್ಟೆ ಮತ್ತು ನಿರ್ವಹಣಾ ಸಾಮರ್ಥ್ಯಕ್ಕೆ ತಳಿ ಹೊಂದಿಸುವ ಚೌಕಟ್ಟು.",
        category: "ಆರಂಭಿಸುವಿಕೆ",
    },
    "understanding-milk-fat": {
        title: "ಹಾಲಿನ ಕೊಬ್ಬು ಅರ್ಥಮಾಡಿಕೊಳ್ಳುವುದು",
        excerpt: "30-ಲೀಟರ್ ಹಸುಗಳಿಗಿಂತ 5% ಕೊಬ್ಬಿನ ಹಸುಗಳು ಏಕೆ ಹೆಚ್ಚು ಲಾಭದಾಯಕವಾಗಬಹುದು — SNF, ಪ್ರೋಟೀನ್ ಮತ್ತು ಹಾಲಿನ ಬೆಲೆಗಳ ಸರಳ ವಿವರಣೆ.",
        category: "ಆರ್ಥಿಕತೆ",
    },
    "feed-economics": {
        title: "ಆಹಾರದ ಆರ್ಥಿಕತೆ",
        excerpt: "ಆಹಾರವು ನಿಮ್ಮ ವೆಚ್ಚದ 65%. ಪ್ರತಿ ಋತುವಿನಲ್ಲಿ ಲಾಭವನ್ನು ಆರೋಗ್ಯಕರವಾಗಿಡುವ ಸಾಂದ್ರ-ಟು-ಮೇವು ಅನುಪಾತ ಕಲಿಯಿರಿ.",
        category: "ಆರ್ಥಿಕತೆ",
    },
    "daily-operating-costs": {
        title: "ಒಂದು ಹಾಲಿನ ಹಸು ದಿನಕ್ಕೆ ನಿಜವಾಗಿ ಎಷ್ಟು ವೆಚ್ಚ?",
        excerpt: "ಆಹಾರ, ಶ್ರಮ, ವಿದ್ಯುತ್, ಪಶು ಚಿಕಿತ್ಸೆ ಮತ್ತು ಸವಕಳಿಯ ಪಾರದರ್ಶಕ ವಿಭಜನೆ — ಬಹುತೇಕ ರೈತರು ಎಂದೂ ಲೆಕ್ಕ ಹಾಕದ ಸಂಖ್ಯೆಗಳು.",
        category: "ಆರ್ಥಿಕತೆ",
    },
    "dairy-shed-design": {
        title: "ಡೇರಿ ಶೆಡ್ ವಿನ್ಯಾಸ",
        excerpt: "ವಾಯುಪ್ರಸರಣ, ನೆಲದ ಇಳಿಜಾರು, ಒಳಚರಂಡಿ ಮತ್ತು ದಿಕ್ಕು — ಇಂದು ನೀವು ಕಟ್ಟುವ ಶೆಡ್ ಮುಂದಿನ ಹದಿನೈದು ವರ್ಷಗಳ ನಿಮ್ಮ ಉತ್ಪಾದನೆಯನ್ನು ನಿರ್ಧರಿಸುತ್ತದೆ.",
        category: "ಮೂಲಸೌಕರ್ಯ",
    },
    "vaccination-schedule": {
        title: "ಲಸಿಕೆ ವೇಳಾಪಟ್ಟಿ",
        excerpt: "FMD, HS, BQ, ಬ್ರೂಸೆಲೋಸಿಸ್ — ಕರುವಿನಿಂದ ವಯಸ್ಕವರೆಗೆ ಪ್ರತಿ ಕರ್ನಾಟಕ ರೈತನೂ ಅನುಸರಿಸಬೇಕಾದ ಕ್ಯಾಲೆಂಡರ್.",
        category: "ಆರೋಗ್ಯ",
    },
    "milking-hygiene": {
        title: "ಹಾಲುಕರೆಯುವ ನೈರ್ಮಲ್ಯ",
        excerpt: "ಸ್ವಚ್ಛವಾಗಿ ಹಾಲುಕರೆಯುವಿಕೆಯು ಪ್ರೀಮಿಯಂ ಮತ್ತು ತಿರಸ್ಕರಿಸಲ್ಪಟ್ಟ ಹಾಲಿನ ನಡುವಿನ ವ್ಯತ್ಯಾಸ. ಕರ್ನಾಟಕ ಸಹಕಾರಿಗಳಲ್ಲಿ ಸಾಬೀತಾದ ಹಂತ-ಹಂತದ ಪ್ರೋಟೋಕಾಲ್.",
        category: "ಕಾರ್ಯಾಚರಣೆ",
    },
    "heat-stress-management": {
        title: "ಶಾಖ ಒತ್ತಡ ನಿರ್ವಹಣೆ",
        excerpt: "ಕರ್ನಾಟಕದ ಬೇಸಿಗೆಗಳು ಉತ್ಪಾದನೆಯನ್ನು 30% ವರೆಗೆ ಇಳಿಸಬಹುದು. ವರ್ಷವಿಡೀ ಉತ್ಪಾದನೆಯನ್ನು ರಕ್ಷಿಸುವ ಸರಳ, ಕಡಿಮೆ-ವೆಚ್ಚದ ತಂಪುಗಾರಿಕೆ ತಂತ್ರಗಳು.",
        category: "ಕಾರ್ಯಾಚರಣೆ",
    },
    "common-beginner-mistakes": {
        title: "ಸಾಮಾನ್ಯ ಆರಂಭಿಕರ ತಪ್ಪುಗಳು",
        excerpt: "ಹೊಸ ಡೇರಿ ಫಾರ್ಮ್‌ಗಳಲ್ಲಿ ನಾವು ಪ್ರತಿ ತಿಂಗಳು ನೋಡುವ ಹನ್ನೆರಡು ದುಬಾರಿ ತಪ್ಪುಗಳು — ಮತ್ತು ಪ್ರತಿಯೊಂದನ್ನೂ ಹೇಗೆ ತಪ್ಪಿಸಬಹುದಾಗಿತ್ತು.",
        category: "ಆರಂಭಿಸುವಿಕೆ",
    },
    "profitability-planning": {
        title: "ಲಾಭದಾಯಕತೆ ಯೋಜನೆ",
        excerpt: "ಹತ್ತು-ಹಸು ಫಾರ್ಮ್ ಆದಾಯ-ಮತ್ತು-ವೆಚ್ಚ ಮಾದರಿ — ಜೊತೆಗೆ ಲಾಭದಾಯಕ ಡೇರಿಗಳನ್ನು ಸಮಸ್ಯೆಗಳ ಡೇರಿಗಳಿಂದ ಬೇರ್ಪಡಿಸುವ ನಾಲ್ಕು ಸನ್ನೆಗೋಲುಗಳು.",
        category: "ಆರ್ಥಿಕತೆ",
    },
};

export const galleryTranslationsKN = {
    1: { caption: "ಹೊಲದ ಅಂಚಿನಲ್ಲಿ ಬೆಳಗಿನ ಝಾವ", category: "ಪ್ರಕೃತಿ" },
    2: { caption: "ಗಿರ್ ಹಸು, ಸುವರ್ಣ ಸಮಯ", category: "ಭಾವಚಿತ್ರ" },
    3: { caption: "ಕಾಂಕ್ರೇಜ್, ಧೂಳಿನಲ್ಲಿ ಬೆಳ್ಳಿ", category: "ಭಾವಚಿತ್ರ" },
    4: { caption: "ಹಳ್ಳಿಕಾರ್, ಕರ್ನಾಟಕದ ಸ್ಥಳೀಯ", category: "ಭಾವಚಿತ್ರ" },
    5: { caption: "ತಾಯಿ ಮತ್ತು ಕರು, ಟೆರಾಕೋಟಾ ಬೆಳಕು", category: "ಕರುಗಳು" },
    6: { caption: "ಮೊದಲ ತಿಂಗಳು", category: "ಕರುಗಳು" },
    7: { caption: "ಹಾಲ್‌ಸ್ಟೀನ್ ಫ್ರೀಸಿಯನ್, ಮಂಜು ಬೆಟ್ಟಗಳು", category: "ಪ್ರಕೃತಿ" },
    8: { caption: "ಗಾಢ ಸಮಯ", category: "ಭಾವಚಿತ್ರ" },
    9: { caption: "ಜರ್ಸಿ, ಒಂದು ಅಧ್ಯಯನ", category: "ಭಾವಚಿತ್ರ" },
    10: { caption: "ಹಸಿರಿನಲ್ಲಿ ಭಾವಚಿತ್ರ", category: "ಕರುಗಳು" },
};

export const quizTranslationsKN = {
    region: {
        title: "ನಿಮ್ಮ ಫಾರ್ಮ್ ಕರ್ನಾಟಕದಲ್ಲಿ ಎಲ್ಲಿದೆ?",
        subtitle: "ಯಾವ ತಳಿ ನಿಜವಾಗಿ ಬೆಳೆಯುತ್ತದೆ ಎಂಬುದನ್ನು ಹವಾಮಾನ ರೂಪಿಸುತ್ತದೆ.",
        options: {
            ghats: { label: "ತಂಪಾದ ಘಾಟಿಗಳು", desc: "ಚಿಕ್ಕಮಗಳೂರು, ಹಾಸನ, ಕೊಡಗು, ಶಿವಮೊಗ್ಗ" },
            plateau: { label: "ಕೇಂದ್ರ ಪ್ರಸ್ಥಭೂಮಿ", desc: "ಮೈಸೂರು, ಮಂಡ್ಯ, ಬೆಂಗಳೂರು ಗ್ರಾಮಾಂತರ, ತುಮಕೂರು" },
            north: { label: "ಉತ್ತರ ಕರ್ನಾಟಕ", desc: "ಬಾಗಲಕೋಟೆ, ವಿಜಯಪುರ, ರಾಯಚೂರು, ಬಳ್ಳಾರಿ, ಕಲಬುರಗಿ" },
            malnad: { label: "ಮಲನಾಡು ಹೃದಯಭಾಗ", desc: "ಮೈಸೂರು, ಚಾಮರಾಜನಗರ, ಹಳೆಯ ಮೈಸೂರು ಬೆಲ್ಟ್" },
            unsure: { label: "ಇನ್ನೂ ಖಚಿತವಿಲ್ಲ", desc: "ಸ್ಥಳ ನಿರ್ಧರಿಸುತ್ತಿದ್ದೇನೆ" },
        },
    },
    goal: {
        title: "ನಿಮ್ಮ ಪ್ರಾಥಮಿಕ ಹೈನುಗಾರಿಕೆ ಗುರಿ ಏನು?",
        subtitle: "ದ್ರವ ಹಾಲು, ತುಪ್ಪ, A2 ಅಥವಾ ಪರಂಪರೆ — ಇವು ವಿಭಿನ್ನ ತಳಿಗಳನ್ನು ಬೇಡುತ್ತವೆ.",
        options: {
            volume: { label: "ಗರಿಷ್ಠ ದೈನಂದಿನ ಪ್ರಮಾಣ", desc: "ದ್ರವ-ಹಾಲಿನ ಸಹಕಾರಿ ಒಪ್ಪಂದಗಳಿಗೆ ಮಾರಾಟ" },
            ghee: { label: "ಪ್ರೀಮಿಯಂ ತುಪ್ಪ ಮತ್ತು ಪನೀರ್", desc: "ಹೆಚ್ಚಿನ ಕೊಬ್ಬು ಮತ್ತು SNF ಇರುವ ಮೌಲ್ಯವರ್ಧಿತ ಉತ್ಪನ್ನಗಳು" },
            a2: { label: "A2 ಹಾಲು / ಸಾವಯವ ಪ್ರೀಮಿಯಂ", desc: "ಹೆಚ್ಚಿನ ಲಾಭಾಂಶದಲ್ಲಿ ಬ್ರಾಂಡೆಡ್ ನೇರ-ಗ್ರಾಹಕ" },
            household: { label: "ಮನೆ + ಬದಿ ಆದಾಯ", desc: "ಕುಟುಂಬದ ಹಾಲು ಜೊತೆಗೆ ಸಣ್ಣ ಹೆಚ್ಚುವರಿ ಮಾರಾಟ" },
            heritage: { label: "ಪರಂಪರೆ ಮತ್ತು ಸಂರಕ್ಷಣೆ", desc: "ಭಾರತೀಯ ತಳಿಗಳು ಮತ್ತು ಸಾಂಸ್ಕೃತಿಕ ಕೃಷಿ ಸಂರಕ್ಷಣೆ" },
        },
    },
    budget: {
        title: "ಪ್ರತಿ ಹಾಲುಕೊಡುವ ಹಸುವಿಗೆ ನಿಮ್ಮ ಹೂಡಿಕೆ ಸಾಮರ್ಥ್ಯ?",
        subtitle: "ಶೆಡ್ ಅಥವಾ ಉಪಕರಣಗಳಲ್ಲದೆ, ಖರೀದಿಯನ್ನು ಒಳಗೊಂಡಿದೆ.",
        options: {
            u50: { label: "₹50,000 ಕ್ಕಿಂತ ಕಡಿಮೆ", desc: "ಬಹಳ ಸಣ್ಣ ಬಜೆಟ್" },
            b50_80: { label: "₹50k – ₹80k", desc: "ಸಾಧಾರಣ ಮೊದಲ ಖರೀದಿ" },
            b80_100: { label: "₹80k – ₹1,00,000", desc: "ಗಂಭೀರ ಮೊದಲ ಹೂಡಿಕೆ" },
            b100p: { label: "₹1,00,000+ ಪ್ರತಿ ಹಸು", desc: "ಪ್ರೀಮಿಯಂ ಜೀನ್‌ಗಳು ಲಭ್ಯ" },
        },
    },
    labour: {
        title: "ಪ್ರತಿ ಹಸುವಿಗೆ ದಿನಕ್ಕೆ ನೀವು ಎಷ್ಟು ಶ್ರಮ ನೀಡಬಹುದು?",
        subtitle: "ಆಹಾರ, ಸ್ವಚ್ಛತೆ, ಹಾಲುಕರೆಯುವಿಕೆ, ದಾಖಲೆಗಳನ್ನು ಒಳಗೊಂಡಿದೆ.",
        options: {
            under15: { label: "1.5 ಗಂಟೆಗಿಂತ ಕಡಿಮೆ", desc: "ಮನೆ-ಮಟ್ಟದ ಆರೈಕೆ" },
            "15_2": { label: "1.5 – 2 ಗಂಟೆಗಳು", desc: "ಗಮನ ಕೇಂದ್ರೀಕರಿಸಿದ ಸಣ್ಣ ಫಾರ್ಮ್" },
            "2_25": { label: "2 – 2.5 ಗಂಟೆಗಳು", desc: "ಸಣ್ಣ-ವಾಣಿಜ್ಯಿಕ ಸೆಟಪ್" },
            over25: { label: "2.5+ ಗಂಟೆಗಳು", desc: "ಪೂರ್ಣ ವಾಣಿಜ್ಯಿಕ ಕಾರ್ಯಾಚರಣೆ" },
        },
    },
    experience: {
        title: "ನಿಮ್ಮ ಹೈನುಗಾರಿಕೆ ಅನುಭವ?",
        subtitle: "ಪ್ರಾಮಾಣಿಕ ಉತ್ತರಗಳು ಪ್ರಾಮಾಣಿಕ ಶಿಫಾರಸು ನೀಡುತ್ತವೆ.",
        options: {
            beginner: { label: "ಸಂಪೂರ್ಣ ಆರಂಭಿಕ", desc: "ಮೊದಲ ಡೇರಿ ಖರೀದಿ" },
            some: { label: "ಸ್ವಲ್ಪ ಕೈ-ಆನ್ ಅನುಭವ", desc: "1–3 ವರ್ಷ ಜಾನುವಾರುಗಳೊಂದಿಗೆ" },
            experienced: { label: "ಅನುಭವಿ / ವಾಣಿಜ್ಯಿಕ", desc: "ವಾಣಿಜ್ಯಿಕ ಡೇರಿ ನಡೆಸುತ್ತಿರುವ ಅಥವಾ ಕೆಲಸ ಮಾಡಿದ" },
        },
    },
};
